<template>
  <div class="open-data-container">
    <div class="menu-data">
      <el-menu
        default-active="1-0"
        popper-class="menu-data-nav"
        @close="handleClose"
        default-openeds="[1]"
      >
        <el-submenu index="1">
          <template #title>
            <i class="el-icon-s-unfold"></i>
            <span>机构分类</span>
          </template>
          <el-menu-item index="1-0" @click="chengeDepartment(null)">
            <span>．全部</span> <span>({{ departmentCount }})</span>
          </el-menu-item>
          <el-menu-item
            v-for="(item, index) in departmentCategroy"
            :key="index"
            :index="'1-' + index + 1"
            @click="chengeDepartment(item.id)"
          >
            <span>．{{ item.name }}</span>
            <span>({{ item.ifaceCount ? item.ifaceCount : 0 }})</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="data-info">
      <div class="data-categroy">
        <div class="data-domain frow">
          <label>领域： </label>
          <div
            class="type-item first-item"
            :class="{ active: domainIndex == null }"
            @click="changeDomainIndex(null, null)"
          >
            不限
          </div>
          <div class="type-list">
            <div
              v-for="(item, index) in domainList"
              :key="index"
              class="type-item"
              :class="{ active: domainIndex == index }"
              @click="changeDomainIndex(index, item.id)"
            >
              {{ item.name
              }}<span>({{ item.ifaceCount ? item.ifaceCount : 0 }})</span>
            </div>
          </div>
        </div>

        <div class="data-search frow">
          <label>筛选：</label>
          <el-input
            placeholder="请输入筛选名称"
            @keyup.enter="search"
            v-model="queryForm.name"
          >
            <template #append>
              <el-button type="primary" @click="search" icon="el-icon-search"
                >搜索</el-button
              >
            </template>
          </el-input>
        </div>
      </div>

      <el-table
        :data="list"
        v-loading="tableLoading"
        class="open-table"
        :span-method="objectSpanMethod"
        :row-style="{ height: '10px' }"
        :cell-style="{ height: '10px' }"
        style="width: 100%"
        :header-row-style="{ background: '#FFF', color: '#555' }"
      >
        <el-table-column
          prop="title"
          :label="'共' + queryForm.total + '个数据'"
          width="500"
        >
          <template v-slot="{ row }">
            <div class="intable-row ">
              <div class="intable-row-left">
                <router-link
                  :to="'/interface/detail/' + row.id"
                  style="color:#2A7EE3"
                  >{{ row.name }}
                </router-link>
                <el-rate v-model="row.averageScore" disabled></el-rate>
              </div>
              <div class="intable-row-right">
                <!-- <span>数据容量：{{ row.dataCount ? row.dataCount : 0 }}</span> -->
                <span
                  style="display:flex;algin-item:center;"
                  @click="collcet(row.id, row.name)"
                  ><img
                    src="@/assets/icon_collect.png"
                    style="width:16px;height:16px;margin-right:10px"
                    alt=""
                  />收藏</span
                >
              </div>
            </div>
            <div class="intable-row">
              <div class="intable-row-left" style="display:block">
                {{ row.summary }}
              </div>
              <div class="intable-row-right">
                <router-link
                  :to="
                    '/user/index?iface=' + row.id + '&dataset=' + row.datasetId
                  "
                >
                  <div class="in-box">接口申请</div>
                </router-link>
                <router-link
                  v-if="row.datasetId"
                  :to="'/data_public/detail/data_preview/' + row.datasetId"
                >
                  <div class="in-box" style="margin-left:10px">数据预览</div>
                </router-link>
              </div>
            </div>

            <div class="intable-row">
              <div class="intable-row-left">
                <span>提供者： {{ row.companyName }}</span>
                <span>数据领域： {{ row.appTypeName }}</span>
              </div>
              <div class="intable-row-right">
                <span>查看：{{ row.viewCount ? row.viewCount : 0 }}</span>
                <!-- <span>下载：{{ row.downCount ? row.downCount : 0 }}</span> -->
                <span>更新时间：{{ row.lastUpdateTime }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="lastUpdateTime" label="更新时间" sortable>
          <template> </template>
        </el-table-column>
        <!-- <el-table-column prop="dataCount" sortable label="数据量">
          <template> </template>
        </el-table-column> -->
        <el-table-column prop="viewCount" sortable label="访问量">
          <template> </template>
        </el-table-column>
        <!-- <el-table-column prop="downCount" sortable label="下载量">
          <template> </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        small
        :current-page="queryForm.curPageNumber"
        :page-size="queryForm.pageSize"
        :total="queryForm.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { collcet } from "@/api/user";
import { getAppMarkHot, getOrg, getInterfaceList } from "@/api/index";
export default {
  data() {
    return {
      queryForm: {
        name: "",
        curPageNumber: 1,
        pageSize: 10,
        total: 0,
        fileType: "",
        appTypeId: "",
        companyId: ""
      },
      pageData: {},
      departmentCount: 0,
      tableLoading: true,
      list: [],
      isCollapse: true,
      domainIndex: null,
      fileTypeIndex: null,
      fileTypeList: [
        {
          title: "XLS"
        },
        {
          title: "XML"
        },
        {
          title: "JSON"
        },
        {
          title: "CSV"
        },
        {
          title: "RDF"
        }
      ],
      domainList: [],
      departmentCategroy: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async collcet(id, name) {
      let { message } = await collcet({
        refId: id,
        collectName: name,
        collectType: "DATAFACE"
      });
      this.$message({
        message: message,
        type: "success"
      });
    },
    handleClose() {},
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.queryForm.curPageNumber = val;
      this.fetchData();
    },
    chengeDepartment(id) {
      this.queryForm.companyId = id;
      this.fetchData();
    },
    changeDomainIndex(index, id) {
      this.domainIndex = index;
      this.queryForm.appTypeId = id;
      this.fetchData();
    },
    changeFileTypeIndex(index, title) {
      this.fileTypeIndex = index;
      this.queryForm.fileType = title;
      this.fetchData();
    },
    async init() {
      var { result } = await getAppMarkHot();
      this.domainList = result;
      var data = await getOrg({ dataType: "PROVINCIAL" });
      this.departmentCategroy = data.result;
      this.departmentCategroy.map(item => {
        this.departmentCount += item.ifaceCount ? item.ifaceCount : 0;
      });
      this.fetchData();
    },
    async fetchData() {
      this.tableLoading = true;
      var data = await getInterfaceList(this.queryForm);
      this.queryForm.total = data.result.count;

      this.list = data.result.data;

      this.tableLoading = false;
    },
    objectSpanMethod({ columnIndex }) {
      if (columnIndex === 0) {
        return [1, 5];
      }
    },

    search() {
      this.fetchData();
    }
  }
};
</script>
<style lang="scss" scoped>
.el-table {
  overflow: hidden;
  /deep/tbody tr:hover > td {
    background-color: #ffffff;
  }
}
.open-data-container {
  .el-table .el-table__row .cell {
    padding-left: 35px;
    a {
      color: #333333;
    }
  }
  .el-menu-item * {
    vertical-align: middle;
    max-width: 100px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .intable-row-left {
    display: flex;
    flex-direction: row;

    max-width: 700px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .el-rate {
      margin-left: 20px;
    }
  }
  padding-bottom: 108px;
  display: flex;
  flex-direction: row;
  .data-info {
    width: 980px;
    margin-left: 20px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    /deep/ .frow {
      margin-bottom: 20px;
    }
    .open-table {
      font-size: 13px;
      font-weight: 400;
      color: #333333 !important;
      line-height: 18px;
      .info-top {
        display: flex;
        flex-direction: row;
        font-weight: 500 !important;
        .el-rate {
          margin-left: 25px;
        }
      }
      .intable-row:last-child .intable-row-right {
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
      }
      .intable-row {
        margin-top: 12px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .intable-row-right {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          min-width: 130px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .in-box {
            padding: 2px 16px;
            border-radius: 2px;
            border: 1px solid #438aca;
            color: #438aca;
            font-size: 12px;
            font-weight: 500;
            color: #438aca;
            line-height: 17px;
            height: 20px;
            width: 90px;
            text-align: center;
          }
          img {
            margin-left: 20px;
          }
          align-items: center;
          line-height: 20px;
          span {
            margin-left: 30px;
          }
        }
      }
    }
    .data-categroy {
      padding: 25px 30px;
      .active {
        color: #2a7ee3;
      }
      .type-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 770px;
      }
      .data-domain {
        align-items: baseline;
      }
      .data-type {
        .first-item {
          margin-top: 0;
        }
        .type-item {
          margin-top: 0;
        }
      }
      .type-item {
        margin-top: 10px;
        margin-left: 25px;
        width: 100px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        span {
          margin-left: 10px;
        }
      }

      .first-item {
        width: 60px !important;
        margin-left: 10px !important;
      }
      label {
        width: 50px !important;
      }
      .el-button {
        border-radius: 0px 2px 2px 0px !important;
      }
    }
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }
  .menu-data /deep/.el-menu {
    width: 210px;
    min-height: 1035px;
    border: 1px solid #eeeeee;
  }
  .el-submenu /deep/ .el-submenu__title {
    background: #2a7ee3 !important;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff !important;
  }
  .el-submenu /deep/ .el-submenu__title .el-submenu__icon-arrow {
    // border-radius: 50%;
    // border: 1px solid #8bc0ff;
    // padding: 2px
    &::before {
      content: "";
    }
  }
  .menu-data /deep/ .el-menu-item {
    padding-left: 12px !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }

  .open-data-container /deep/ .el-button--primary {
    border-radius: 0px 2px 2px 0px !important;
  }
}
</style>
